<template>
    <div class="page">
        <public-head title="历年真题"></public-head>
        <div class="menu">
            <div v-for="(item,index) in lists" :key="index">
                <div
                    :class="firstNavId === item.id?'menu-item-on':'menu-item-off'"
                    @click="selectMenu(item,index)"
                >
                    <div>{{item.name}}</div>
                </div>
            </div>
            <img
                class="title-img"
                src="https://new.schoolpi.net/attach/small_program/class/search.png"
                @click="goSearch"
            />
        </div>
      
        <div class="choose" v-if="bottomNav.length>0">
            <div v-for="(item,index) in bottomNav" :key="index">
                <div class="nav-con">
                    <div
                        @click="choose(item,index)"
                        :class="secondNavId === item.id?'header':'nav-con'"
                    >{{item.name}}</div>
                </div>
            </div>
        </div>
        <div v-if="policyList.length>0">
            <div class="main">
                <!-- 考试大纲 -->
                <van-list v-if=" index===0" finished-text="没有更多了" @load="onLoad" :finished="finished">
                    <div v-for="(item,index) in policyList" :key="index">
                        <div class="content" @click="goSchoolSubject(item)">
                            <div class="course" :style="{backguound:item.tags_color}">{{item.tags}}</div>
                            <div class="title">{{item.title}}</div>
                            <div class="time">{{item.addtime}}</div>
                        </div>
                    </div>
                </van-list>

                <!-- 校考题库 -->
                <van-list v-if=" index===1" finished-text="没有更多了" @load="onLoad" :finished="finished">
                    <!-- 安徽 -->
                    <div class="_container" v-if="schoolLists.length>0&&id==14234">
                        <div v-for="(item,index) in schoolLists" :key="index">
                            <div class="school-item" @click="goSchoolSubjectLIst(item)">
                                <img class="school-logo" :src="item.logo" />
                                <div class="school-info">
                                    <div class="school-name">{{item.name}}</div>
                                    <div class="flex">
                                        <div class="info-item">{{item.arr.one}}</div>
                                        <div class="info-item">{{item.arr.two}}</div>
                                    </div>
                                    <div class="flex">
                                        <div class="info-item">{{item.arr.threee}}</div>
                                        <div class="info-item">{{item.arr.four}}</div>
                                    </div>
                                </div>
                                <div class="school-hot">人气:{{item.mood==null?'0':item.mood}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 江苏 -->
                    <div class="_container" v-if="schoolLists.length>0&&id==10808">
                        <div v-for="(item,index) in schoolLists" :key="index">
                            <div class="school-item" @click="goSchoolSubjectLIst(item)">
                                <img class="school-logo" :src="item.logo" />
                                <div class="school-info">
                                    <div class="school-name">{{item.name}}</div>
                                    <div class="flex">
                                        <div class="befor">提前</div>
                                        <div class="info-item2">{{item.arr.duikou_one}}</div>
                                        <div class="counterpart">对口</div>
                                        <div class="info-item2">{{item.arr.tiqian_one}}</div>
                                    </div>
                                </div>
                                <div class="school-hot">人气:{{item.mood==null?'0':item.mood}}</div>
                            </div>
                        </div>
                    </div>
                </van-list>
                <!-- 文化测试题 -->
                <van-list v-if=" index===2" finished-text="没有更多了" @load="onLoad" :finished="finished">
                    <div v-for="(item,index) in policyList" :key="index">
                        <div class="content" @click="goSchoolSubject(item)">
                            <div class="course" :style="{backguound:item.tags_color}">{{item.tags}}</div>
                            <div class="title">{{item.title}}</div>
                            <div class="time">{{item.addtime}}</div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
        <div v-else class="_noPost">
            <img
                src="https://new.schoolpi.net/attach/small_program/index/no-data.png"
                class="no-data"
            />
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            show: false,
            firstNavId: 0, //第一层id、
            secondNavId: 0, //第二层id
            lists: [],
            bottomNav: [],
            index: 0,
            policyList: [], //历年真题列表数据
            schoolLists: [], //校考题库学校列表数据
            page: 1,
            cateId: "",
            name: "",
            id: 0,
            finished:false
        };
    },
    created() {},
    methods: {
        // 上拉加载
        onLoad() {
            this.page = this.page + 1;
            if (this.name == "校考题库") {
                httpPost("/classifie/question_school", {
                    province: this.$store.state.areaInfo.pid,
                    cate_id: this.cateId,
                    page: this.page
                }).then(res => {
                    if (res.code === 1) {
                        this.schoolLists = [...this.schoolLists, ...res.list];
                        this.$toast.loading({
                            message: "加载中...",
                            forbidClick: true
                        });
                    } else {
                        this.finished = true;
                    }
                });
            }
            if (this.name == "考试大纲" || this.name == "文化测试真题") {
                httpPost("/classifie/question_list", {
                    province: this.$store.state.areaInfo.pid,
                    cate_id: this.cateId,
                    page: this.page
                }).then(res => {
                    if (res.code === 1) {
                        this.policyList = [...this.policyList, ...res.list];
                        this.$toast.loading({
                            message: "加载中...",
                            forbidClick: true
                        });
                    } else {
                        this.finished = true;
                    }
                });
            }
        },
        // 进入搜素页面
        goSearch() {
            this.$router.push("/fenlei/search?go=" + 2);
        },
        // 点击一级菜单
        selectMenu(e, index) {
            if (e.child.length === 0) {
                this.firstNavId = e.id;
                this.secondNavId = e.id;
                this.bottomNav = e.child;
                this.index = index;
            } else {
                let secondNavId = e.child[0].id;
                this.firstNavId = e.id;
                this.secondNavId = secondNavId;
                this.bottomNav = e.child;
                this.index = 0;
                this.fetchPolicyList(secondNavId);
            }
            if (e.name === "考试大纲") {
                this.fetchPolicyList(e.id);
            }
            if (e.name === "校考题库") {
                this.fetchSchoolBank(e.id);
            }
            if (e.name === "文化测试真题") {
                this.fetchPolicyList(e.id);
            }
            this.cateId = e.id;
            this.name = e.name;
        },
        // 点击二级菜单
        choose(e, i) {
            (this.secondNavId = e.id), (this.index = i);
            this.fetchPolicyList(e.id);
            (this.cateId = e.id), (this.name = e.name);
            if (e.name === "考试大纲") {
                this.fetchPolicyList(e.id);
            }
            if (e.name === "校考题库") {
                this.fetchSchoolBank(e.id);
            }
            if (e.name === "文化测试真题") {
                this.fetchPolicyList(e.id);
            }
        },
        // 进入学校题目详情
        goSchoolSubject(e) {
            this.$router.push({
                path: "/fenlei/subjectDetail",
                query: {
                    id: e.id
                }
            });
        },
        // 进入学校题目列表
        goSchoolSubjectLIst(e) {
           
            this.$router.push({
                path: "/fenlei/schoolSubjectLIst",
                query: {
                    sid: e.sid
                }
            });
        },
        //获取历年真题分类菜单数据
        fetchCate() {
            httpPost("/classifie/question_cate", {
                province:this.$store.state.areaInfo.pid
            }).then(res => {
             
                if (res.code === 1) {
                    this.firstNavId = res.list[0].id;
                    this.bottomNav = res.list[0].child;
                    if (this.bottomNav.length > 0) {
                        //江苏
                        this.lists = res.list;
                        this.secondNavId = this.bottomNav[0].id;
                       
                        this.fetchPolicyList(this.secondNavId);
                    } else {
                        //安徽
                        this.lists = res.list;
                        this.firstNavId = res.list[0].id;
                        this.fetchPolicyList(this.firstNavId);
                    }
                }
            });
        },
        // 获取历年真题列表数据
        fetchPolicyList(cate_id) {
         
            httpPost("/classifie/question_list", {
                province:this.$store.state.areaInfo.pid,
                cate_id: cate_id
            }).then(res => {
               
                if (res.code === 1) {
                    this.policyList = res.list;
                } else {
                    let empty = [];
                    this.policyList = empty;
                }
            });
        },
        //获取校考题库学校列表数据
        fetchSchoolBank(cate_id) {
            httpPost("/classifie/question_school", {
                province:this.$store.state.areaInfo.pid,
                cate_id: cate_id
            }).then(res => {
               
                if (res.code === 1) {
                    this.schoolLists = res.list;
                }
            });
        }
    },
    mounted() {
        this.id = this.$store.state.areaInfo.pid;
        this.fetchCate();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
   width: 100%;
    background: #f2f2f2;
    min-height: 93vh;
}
.menu {
    border-top: 1px solid transparent;
    padding: 0 0.9375rem;
    height: 3.125rem;
    line-height: 3.125rem;
    display: flex;
    justify-content: space-around;
    background: #22d8d9;
    color: #fff;
    font-size: 0.875rem;
    margin-top: 46px;
}
.title-img {
    margin-top: 0.8125rem;
    width: 1.6875rem;
    height: 1.6875rem;
}
.choose {
    height: 3.9375rem;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0.8125rem 0;
}
.menu-item-on {
    font-size: 1.125rem;
}
.main {
    box-sizing: border-box;
    padding: 0 0.9375rem;
}
.content {
    width: 100%;
    height: 6.25rem;
    background: #ffff;
    margin-top: 0.625rem;
    position: relative;
    padding: 0.9375rem;
    box-sizing: border-box;
    border-radius: 10rpx;
}
.course {
    width: 2.5rem;
    height: 1.125rem;
    display: inline;
    background: #fed2cd;
    border: 1px solid #fe7666;
    font-size: 0.8125rem;
    color: #fe7666;
    border-radius: 1px 5px 1px 5px;
    margin-right: 0.625rem;
}
.title {
    display: inline;
    font-size: 1.0625rem;
    line-height: 1.5625rem;
    font-weight: bold;
}
.time {
    position: absolute;
    bottom: 0.9375rem;
    right: 0.9375rem;
    color: #a9a9a9;
}
.header {
    width: 100%;
    text-align: center;
    line-height: 2.125rem;
    background: #22d8d9;
    color: #fff;
    font-size: 0.875rem;
    border-radius: 0.9375rem;
}

.nav-con {
    width: 6.5rem;
    height: 2.125rem;
    background: #e6e6e6;
    border-radius: 0.9375rem;
    text-align: center;
    line-height: 2.125rem;
}
._noPost {
    text-align: center;
    position: relative;
}
.no-data {
    width: 6.25rem;
    height: 6.25rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}

.school-item {
    display: flex;
    margin-top: 0.625rem;
    height: 5rem;
    background: #fff;
    position: relative;
}
.school-logo {
    width: 3.4375rem;
    height: 3.4375rem;
    margin-top: 0.8125rem;
    border-radius: 1.75rem;
    margin-right: 0.3125rem;
    margin-left: 0.3125rem;
}
.school-name {
    font-size: 0.9375rem;
    margin: 0.625rem 0 0.1875rem 0;
}
.flex {
    display: flex;
    
}
.info-item {
    width: 8.4375rem;
    font-size: 0.75rem;
    color: #a9a9a9;
    margin-bottom: 0.3125rem;
}
.school-hot {
    position: absolute;
    top: 0.8125rem;
    right: 0.9375rem;
    color: #ffbb29;
    font-size: 0.75rem;
}
.befor {
    width: 1.875rem;
    height: 1.25rem;
    background: #ff7373;
    color: #fff;
    font-size: 0.75rem;
    border-radius: 0.3125rem;
    text-align: center;
    line-height: 1.25rem;
    margin-right: 0.3125rem;
}
.counterpart {
    width: 1.875rem;
    height: 1.25rem;
    background: #22d8d9;
    color: #fff;
    font-size: 0.75rem;
    border-radius: 0.3125rem;
    text-align: center;
    line-height: 1.25rem;
    margin-right: 0.3125rem;
}
</style>